import React from "react";
import { Check } from "lucide-react";

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1771270759486-1f7703945072?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

const PILLARS = [
  "Strategy-first engagements",
  "In-house design & engineering",
  "UK-based, Manchester-rooted",
  "Senior team — no juniors on your project",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Acnira creative studio in Manchester"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#050505]/40 via-transparent to-transparent"></div>
            </div>
            <div className="absolute -bottom-8 -right-4 lg:-right-12 glass-strong p-6 max-w-[280px] hidden md:block">
              <div className="font-display text-3xl gold-text-gradient">M4 2BJ</div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-white/60 mt-1">
                Studio · Withy Grove, Manchester
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 text-sm text-white/70 italic font-display">
                "The studio is open. The kettle is on."
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold"></span>
              <span className="text-[11px] uppercase tracking-[0.32em] text-white/60">
                About Acnira
              </span>
            </div>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              We help Manchester businesses
              <em className="gold-text-gradient not-italic"> grow</em> with cutting-edge
              digital craft.
            </h2>
            <p className="mt-8 text-white/65 leading-relaxed">
              Acnira Web Developers is a senior-led, independent studio based at The
              Works on Withy Grove in the heart of Manchester. We partner with founders
              and operators across Greater Manchester — from Michelin-aspiring kitchens
              to multi-branch estate agents — building the websites, applications and
              brands that turn local reputation into national demand.
            </p>
            <p className="mt-4 text-white/55 leading-relaxed">
              Every project is led by a strategist, designed by a director and shipped
              by engineers who have spent more than a decade in the craft. No
              outsourcing. No templates. No compromises.
            </p>

            <ul className="mt-10 grid sm:grid-cols-2 gap-3">
              {PILLARS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-white/80">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center bg-gold/15 text-gold">
                    <Check size={14} strokeWidth={2.5} />
                  </span>
                  <span className="text-sm">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex items-center gap-6">
              <a
                href="#contact"
                data-testid="about-cta"
                className="shine inline-flex items-center px-7 py-3.5 text-sm font-semibold gold-bg-gradient text-black hover:opacity-90 transition-opacity"
              >
                Get Free Quote
              </a>
              <a
                href="#portfolio"
                className="text-sm text-white/70 hover:text-gold transition-colors underline underline-offset-4"
              >
                See recent work
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
